import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

function Desconsolidation({
  onClose,
  valorActual,
  actualizarTarifa,
  concepto,
}) {
  const [monto, setMonto] = useState("");

  // Cargar el valor actual cuando entra a la vista
  useEffect(() => {
    setMonto(valorActual || "");
  }, [valorActual]);

  const handleActualizar = () => {
    if (!monto) return;

    actualizarTarifa(concepto, Number(monto));

    Swal.fire({
      title: "Éxito",
      text: "Monto actualizado con éxito",
      icon: "success",
      customClass: {
        confirmButton: "btn-ok",
        title: "alert-title",
        popup: "alert-bg",
      },
    }).then(() => {
      onClose(); // 🔥 Regresa automáticamente a ImpoTariff
    });
  };

  return (
    <>
      {/* Aquí va la estructura específica */}
      <div className="container-fluid d-flex justify-content-center align-items-center">
        <div className="text-left">
          <div className="mb-4">
            <label className="fw-bold d-block mb-2">
              Desconsolidación (USD)
            </label>
            <input
              type="number"
              className="form-control"
              value={monto}
              onChange={(e) => setMonto(e.target.value)}
            />
          </div>

          <div className="d-flex justify-content-end">
            <button className="btnn" onClick={handleActualizar}>Actualizar</button>
          </div>
        </div>
      </div>
      
    </>
  );
}

export default Desconsolidation;
